import { useNavigate, Link } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/fbConfig';
import React, { useEffect, useState } from 'react';
import { useUserAuth } from "../context/UserAuthContext";
import Logo from '../images/school_logo.png';
import '../styles/Archives.css';

const QuestionsClasses = () => {
  const { userData } = useUserAuth();
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const snap = await getDocs(collection(db, 'classes'));
        const classData = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        // Remove duplicates based on name
        const uniqueClasses = [];
        const seenNames = new Set();
        for (const cls of classData) {
          if (!seenNames.has(cls.name)) {
            seenNames.add(cls.name);
            uniqueClasses.push(cls);
          }
        }
        // Sort by name for consistent display
        const sortedClasses = uniqueClasses.sort((a, b) => a.name.localeCompare(b.name));
        setClasses(sortedClasses);
      } catch (error) {
        console.error('Error fetching classes:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchClasses();
  }, []);

  const allowedRoles = ['Admin', 'Cashier'];

  return (
    <>  
      {allowedRoles.includes(userData?.status) ? (
        <>    
          <div className="top-elements row align-center space-between">
            <button onClick={() => navigate(-1)} className="back-link back-link1">
              <i className="fa-solid fa-arrow-left size3"></i>
            </button>
            <div className="column align-center justify-center">
              <img src={Logo} className="middle-logo" alt="logo" />
            </div>
            <Link to="#" className="home-link" onClick={() => window.location.reload()}>
              <i className="fa-solid fa-rotate-right size4"></i>
            </Link>
          </div>

          <div className="login-page-items column align-center">
            <div className='breadcrumb'>
              <button className="back-link back-link1 back-link2">
                Class
              </button>
            </div>
            <h2 className="manage-page-heading manage-page-heading-select caps size4">Select Class</h2>
            <div className="scroll-fixed scroll-fixed1">
              <div className="class-list class-list-d scrollable class-items">
                {loading ? (
                  <p className="loading-text male-female-stat">Loading classes...</p>
                ) : classes.length === 0 ? (
                  <p className="empty-text male-female-stat">No classes available.</p>
                ) : (
                  classes.map(cls => (
                    <div key={cls.id}>
                      <button
                        className="class-item class-item1 class-item1-d"
                        onClick={() => navigate(`/questions/${cls.id}`)}
                      >
                        {cls.name}
                      </button>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <p className="male-female-stat align-center justify-center">You don't have permission to view this page.</p>
      )}
    </>
  );
};

export default QuestionsClasses;